import {
  ChartBarIcon,
  CpuChipIcon,
  DocumentTextIcon,
  SparklesIcon,
} from "@heroicons/react/24/outline";

// Where the project stands decides what we invite the user to do next.
// tab ids match the tabs in DetailProject. Reads the counts that
// ProjectController::getProjects puts on every project in the list, so both
// the dashboard and the project cards decide this without a detail call.
export function getNextStep(project) {
  if (!project) return null;
  if (!project.analysis_count) {
    return { key: "Upload", tab: 10, icon: DocumentTextIcon };
  }
  // Every file has to be processed before there is anything to code.
  if (project.pending_analysis_count > 0) {
    return {
      key: "Process",
      tab: 0,
      icon: CpuChipIcon,
      files: project.pending_analysis_count,
    };
  }
  if (!project.text_codes_count) {
    return { key: "AiCodes", tab: 4, icon: SparklesIcon };
  }
  return { key: "Results", tab: 7, icon: ChartBarIcon };
}

// Both the dashboard panel and the project cards label the step the same way.
export function nextStepLabels(t, nextStep) {
  if (!nextStep) return null;
  return {
    title: t(`Dashboard.NextStep${nextStep.key}`),
    description: t(`Dashboard.NextStep${nextStep.key}Description`, {
      files: nextStep.files,
    }),
  };
}
